import { useSearchParams } from 'react-router-dom';
import { useResetPassword } from '../hooks/use-reset-password';
import { ResetPasswordForm } from '@/components/organisms/forms/reset-password-form';
import type { ResetPasswordFormData } from '@/lib/validations';

export function ResetPasswordContainer() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('secret');

  const { resetPassword, isLoading, error, success, clearError } = useResetPassword();

  const handleSubmit = async (data: ResetPasswordFormData) => {
    if (!token) return;
    await resetPassword(token, data.password);
  };

  return (
    <ResetPasswordForm
      onSubmit={handleSubmit}
      isLoading={isLoading}
      error={error}
      success={success}
      onErrorClear={clearError}
      tokenMissing={!token}
    />
  );
}
